// extracted by mini-css-extract-plugin
export default {"notFoundWrapper":"NotFound_notFoundWrapper__NUXa+"};